import { Linqset, LinqsetEdge, LinqsetNode, isRoleSystem } from "../../common/linqset-model";
import { ModelInsights, Tag, createModelInsights } from "../../common/organisation";

export class GroupNodeTag {
    insights:ModelInsights
    action:LinqsetNode      // used for showing tag labels

    constructor(linqset:Linqset, public _key:string, public name:string, public description:string, public value?:number, public tag?:Tag) {
        this.insights = createModelInsights(linqset.organisationKey, linqset.workspaceKey, linqset.modelKey)
    }
}

export class LinqsetNodeVisualisation {
    visualisationKey : string
    node: LinqsetNode
    copied: boolean
    excluded: boolean
    highlight:boolean       // whether to highlight the node
    filtered: boolean       // whether the node is filtered
    value:number            // the value for the currently selected label. used for weighting and heatmap

    constructor(node: LinqsetNode, id:string) {
        this.node = node
        this.copied = false
        
        if (isRoleSystem(node.superType)) this.visualisationKey = id
        else this.visualisationKey = node._key
    }

    includeNode() {
        this.excluded = false
        this.node.excluded = false
    }

    excludeVisualisation() {
        this.excluded = true
    }

    excludeNode() {
        this.excluded = true
        this.node.excluded = true
    }

}

export class ModelEdge {
    sourceGroupId:string            // used for edge grouping of ports
    targetGroupId:string            // used for edge grouping of ports
    value:number            // the value for the currently selected label. used for weighting and heatmap
    highlight:boolean       // whether to highlight the edge
    filtered: boolean       // whether the edge is filtered

    private excludedVal:boolean
    nodes:LinqsetNode[] = []            // list of nodes that make up this edge. Used when collapsing/summarising a graph

    constructor(public edge:LinqsetEdge) {
    }

    set excluded(value:boolean) {
        this.excludedVal = value
        this.edge.excluded = value
    }

    get excluded() {
        return this.excludedVal
    }
}

export const createModelEdge = (edge: LinqsetEdge):ModelEdge => {
    return new ModelEdge(edge)
}

